(function () {
  function marquee(root) {
    var track = root.querySelector("[data-mn-about-marquee]");
    if (!track || track.dataset.ready === "1") return;
    track.dataset.ready = "1";
    var html = track.innerHTML;
    track.insertAdjacentHTML("beforeend", html);
  }

  function beliefs(root) {
    var items = root.querySelectorAll("[data-mn-belief]");
    var frames = root.querySelectorAll("[data-mn-belief-frame]");
    if (!items.length || !frames.length) return;

    function activate(index) {
      items.forEach(function (el, n) {
        el.classList.toggle("is-on", n === index);
      });
      frames.forEach(function (el, n) {
        el.classList.toggle("is-on", n === index);
      });
    }

    if (!("IntersectionObserver" in window)) {
      activate(0);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          activate(Number(entry.target.getAttribute("data-mn-belief")) || 0);
        });
      },
      { threshold: 0.55, rootMargin: "-18% 0px -32% 0px" }
    );

    items.forEach(function (item, n) {
      io.observe(item);
      item.addEventListener("click", function () {
        activate(n);
      });
    });
    activate(0);
  }

  function film(root) {
    var scroller = root.querySelector("[data-mn-about-film]");
    if (!scroller) return;
    var prev = root.querySelector("[data-mn-about-prev]");
    var next = root.querySelector("[data-mn-about-next]");
    function step(dir) {
      scroller.scrollBy({ left: dir * Math.min(scroller.clientWidth * 0.86, 640), behavior: "smooth" });
    }
    if (prev) prev.addEventListener("click", function () { step(-1); });
    if (next) next.addEventListener("click", function () { step(1); });
  }

  function bind(root) {
    if (!root || root.dataset.mnAboutReady === "1") return;
    root.dataset.mnAboutReady = "1";
    marquee(root);
    beliefs(root);
    film(root);
  }

  function init() {
    document.querySelectorAll("[data-mn-about]").forEach(bind);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
